// extracted by mini-css-extract-plugin
export var callCard = "_ps-0";
export var callMessageButton = "_ps-1";
export var helpIcon = "_ps-3";
export var helpIconContainer = "_ps-4";
export var verticalDivider = "_ps-2";